
import IndexModelTable from "@/views/paginas/sigap/modelos/IndexModelTable.vue";
import CardRh from "@/components/cards/ManzaCard.vue";
import NotaService from "@/service/v1/sigap/NotaService";
import { Options } from "vue-class-component";
import SiteUtils from "@/assets/ts/aplicacao/site";
import KDataTable from "@/components/datatable/newdatatable.vue";
import $ from "jquery";
import Multiselect from "@vueform/multiselect";
import { PerfilConfig } from "@/core/config/PerfisConfig";

@Options({
    name: "AvaliacaoIndex",
    components: { CardRh, KDataTable, Multiselect },
})
export default class AvaliacaoIndex extends IndexModelTable {
    public status_id: any = 1;
    public status: any = null;
    public tipo_id: any = null;
    public tipo: any = null;
    public cpf = "";
    public pelotao = "";
    public notaMin = "";
    public notaMax = "";
    public disciplina = "";
    public turma = "";
    public search = "";

    get hasPermissao(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE, PerfilConfig.LeituraDE], this.perfis);
    }

    public refreshTable() {
        setTimeout(() => {
            this.reloadDatatable = !this.reloadDatatable;
        }, 300);
    }

    public apertouEnter(e) {
        if (e.key === "Enter" || e.keyCode === 13) {
            this.refreshTable();
        }
    }

    get status_select() {
        if (this.status) {
            return this.status.map((item) => {
                return { value: item.id, label: item.nome };
            });
        }
        return [];
    }

    get tipo_select() {
        if (this.tipo) {
            return this.tipo.map((item) => {
                return { value: item.id, label: item.nome };
            });
        }
        return [];
    }

    public getStatus() {
        this.processando = true;
        this.service.getStatus()
            .then(response => {
                this.status = JSON.parse(JSON.stringify(response));
                this.processando = false;
            })
            .catch(() => {
                this.processando = false;
            });
    }

    public getTipo() {
        this.processando = true;
        this.service.getTipo()
            .then(response => {
                this.tipo = JSON.parse(JSON.stringify(response));
                this.processando = false;
            })
            .catch(() => {
                this.processando = false;
            });
    }

    public limparFiltros() {
        this.search = "";
        this.cpf = "";
        this.status_id = "";
        this.tipo_id = "";
        this.pelotao = "";
        this.notaMin = "";
        this.notaMax = "";
        this.disciplina = "";
        this.turma = "";
        this.refreshTable();
    }

    created() {
        this.service = new NotaService();
        this.getStatus();
        this.getTipo();
        this.config.ajax = {
            url: this.service.getApiUrl(),
            data: (d) => {
                const dados = {
                    Skip: d.start,
                    Take: d.length,
                    cpf: this.cpf,
                    status: this.status_id,
                    tipo: this.tipo_id,
                    pelotao: this.pelotao,
                    disciplina: this.disciplina,
                    notaMax: this.notaMax,
                    notaMin: this.notaMin,
                    turma: this.turma,
                    search: this.search || d.search.value,
                };
                return dados;
            }
        };
        this.config.order = [[0, "asc"],[1, "asc"],[2, "asc"]];
        this.config.columns = [
            { data: "disciplina.turma.descricao", name: "turma"},
            { data: "disciplina.descricao", name: "disciplina"},
            { data: "matricula.usuario.nome", name: "aluno"},
            { data: "tipo", name: "tipo"},
            { data: "notaValor", name: "notavalor"},
            { data: "status", name: "status"},
        ];
        this.config.columnDefs = [
            {
                targets: 3,
                render: function (row) {
                    return row.nome.replaceAll("_", " ");
                }
            },
            {
                targets: 5,
                render: function (row) {
                    return row.nome.replaceAll("_", " ");
                }
            }
        ];
        if (this.hasPermissao) {
            this.pushColunaAcoes();
            this.config.columnDefs.push(
                {
                    targets: 6,
                    render: (row, type, val) => {
                        let texto = "";
                        let buttom = "";
                        for (const key in val) {
                            buttom = buttom + ' data-' + key + '="' + val[key] + '"';
                        }
                        texto = texto + '<button class="btn btn-pmes-primary btn-sm" btn-show-nota ' + buttom + ' title="Visualizar"><i class="fa fa-eye"></i></button>';
                        return texto;
                    },
                }
            );
        }
    }

    public tableatualizada() {
        $("[btn-show-nota]").click((btn) => {
            const id = $(btn.currentTarget).data("id");
            const routeData = this.$router.resolve({ name: "sigap_avaliacao_show", params: { id: id } });
            window.open(routeData.href, "_blank");
        });
    }
}
